import { render, staticRenderFns } from "./principioAtivoSearch.vue?vue&type=template&id=0591bb6c&scoped=true&"
import script from "./principioAtivoSearch.vue?vue&type=script&lang=js&"
export * from "./principioAtivoSearch.vue?vue&type=script&lang=js&"
import style0 from "./principioAtivoSearch.vue?vue&type=style&index=0&id=0591bb6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0591bb6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VFlex,VLayout,VTextField})
